import {FormState} from 'components/Embed/EmbedQuestionnaire'

// eslint-disable-next-line max-params
export const replaceVariables = (text: string, variables: Record<string, string>, formState: FormState, additionalOptions?: Record<string, any>) => {
    let newText = text
    // eslint-disable-next-line prefer-named-capture-group
    const variableRegex = /%([^%]+)%/ug
    const matches = text.match(variableRegex) || []

    matches.forEach((match) => {
        const variableName = match.replaceAll(/%/ug, '')
        const variableValue = variables[variableName]
        if (typeof variableValue !== 'undefined') {
            newText = newText.replace(match, variables[variableName])
        }

        if (formState[`questionnaire-${variableName}`]) {
            const variableFormValue = formState[`questionnaire-${variableName}`].value.toString()
            if (typeof variableFormValue !== 'undefined') {
                newText = newText.replace(match, variableFormValue)
            }
        }

        if (additionalOptions && typeof additionalOptions[variableName] !== 'undefined') {
            const variableAdditionalValue = additionalOptions[variableName].toString()
            if (typeof variableAdditionalValue !== 'undefined') {
                newText = newText.replace(match, variableAdditionalValue)
            }
        }
    })

    return newText
}
